import { render } from "./owners-card.vue?vue&type=template&id=9ee29572"
import script from "./owners-card.vue?vue&type=script&lang=js"
export * from "./owners-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__